<template>
  <div class="animated fadeIn">
    <form>
      <b-row>
        <b-col sm="12">
          <b-card
            id="card-relatorio-pedido"
            :bg-variant="isDark ? 'dark' : 'white'"
            :text-variant="isDark ? 'light' : 'dark'"
            :footer-bg-variant="isDark ? 'dark' : 'light'">
            <div class="p-4 d-flex align-items-center justify-content-between" :class="isDark ? 'bg-secondary-soft' : 'bg-primary-soft'">
              <div>
                <h4 class="mb-1 font-weight-bold" :class="isDark ? 'text-white' : 'text-primary'">
                  <i class="fa fa-file-text-o mr-2"></i>Relatorio de Pedidos de Venda
                </h4>
                <span class="text-muted d-block">Configure os filtros abaixo para gerar o documento em HTML.</span>
              </div>
            </div>

            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-list-alt mr-2"></i>Tipo de Relatorio</h6>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="Modelo">
                    <b-form-select
                      v-model="tipoRelatorio"
                      :options="opcoesRelatorio"
                      :plain="true"
                      class="form-control-lg"
                      :class="isDark ? 'bg-secondary text-white border-info' : 'select-premium'"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="3" sm="12">
                  <b-form-group label="Situacao">
                    <b-form-select
                      ref="comboSituacao"
                      v-model="situacao.valor"
                      :options="situacao.opcoes"
                      :plain="true"
                      class="form-control-lg"
                      :class="isDark ? 'bg-secondary text-white border-info' : 'select-premium'"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="3" sm="12">
                  <b-form-group label="Tipo de Movimentacao">
                    <b-form-select
                      v-model="tipoMovimentacao.valor"
                      :options="tipoMovimentacao.opcoes"
                      :plain="true"
                      class="form-control-lg"
                      :class="isDark ? 'bg-secondary text-white border-info' : 'select-premium'"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-users mr-2"></i>Pessoas</h6>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="Cliente">
                    <cliente-pesquisa
                      @retornaId="filtros.clienteId = $event"
                      :idInicial="filtros.clienteId"
                      label=""
                      place="Todos os clientes"
                      labelBotao=""
                      ref="clientePesquisa"
                      idModal="clientePedidoModal">
                    </cliente-pesquisa>
                  </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                  <b-form-group label="Vendedor">
                    <vendedor-dropdown
                      v-model="filtros.vendedorId"
                      ref="vendedorPesquisa"
                      placeholder="Todos os vendedores"
                      :disabled="isVendedor"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-cubes mr-2"></i>Produtos</h6>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="Produto">
                    <produto-pesquisa
                      @retornaId="filtros.produtoId = $event"
                      :idInicial="filtros.produtoId"
                      label=""
                      place="Todos os produtos"
                      labelBotao=""
                      ref="produtoPesquisa">
                    </produto-pesquisa>
                  </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                  <b-form-group label="Grupo de Produto">
                    <grupo-produto-drop-down
                      v-model="filtros.grupoProdutoId"
                      ref="grupoProdutoPesquisa"
                      placeholder="Todos os grupos"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <div class="section-container mb-2" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-calendar mr-2"></i>Periodo</h6>
              <b-row>
                <b-col md="4" sm="12">
                  <b-form-group label="Tipo de Data">
                    <b-form-select
                      v-model="tipoData.valor"
                      :options="tipoData.opcoes"
                      :plain="true"
                      class="form-control-lg"
                      :class="isDark ? 'bg-secondary text-white border-info' : 'select-premium'"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="4" sm="12">
                  <b-form-group label="Data Inicio">
                    <cec-input-data id="pedidoDt1" v-model="filtros.dt1" :state="filtros.dt1 ? null : false" />
                  </b-form-group>
                </b-col>
                <b-col md="4" sm="12">
                  <b-form-group label="Data Fim">
                    <cec-input-data id="pedidoDt2" v-model="filtros.dt2" :state="filtros.dt2 ? null : false" />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <div class="card-footer-action p-4 text-center mt-2" :class="isDark ? 'bg-dark-darker' : 'bg-white'">
              <b-button size="lg" type="button" variant="primary" @click.stop.prevent="gerarRelatorio()" class="px-5 py-3 btn-pill shadow-lg btn-generate">
                <i class="fa fa-print mr-2"></i> GERAR RELATORIO DE PEDIDOS
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </form>
  </div>
</template>

<script>
import moment from 'moment'
import ClientePesquisa from '../pesquisa/ClientePesquisa.vue'
import ProdutoPesquisa from '../pesquisa/ProdutoPesquisa.vue'
import VendedorDropdown from '../componentes/dropdown/VendedorDropdown.vue'
import GrupoProdutoDropDown from '../componentes/dropdown/GrupoProdutoDropDown.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'
import Tools from '@/tools/tools.js'
import { printGroupedHtmlReport } from '@/utils/RelatorioHTML.js'

export default {
  components: {
    ClientePesquisa,
    ProdutoPesquisa,
    VendedorDropdown,
    GrupoProdutoDropDown,
    CecInputData
  },
  data () {
    return {
      tipoRelatorio: 'ANALITICO_DATA',
      filtros: {
        clienteId: null,
        vendedorId: null,
        produtoId: null,
        grupoProdutoId: null,
        dt1: moment().format('YYYY-MM-DD'),
        dt2: moment().format('YYYY-MM-DD')
      },
      situacao: {
        valor: '1',
        opcoes: [{ value: '', text: 'Todos' }]
      },
      tipoData: {
        valor: 'SAIDA',
        opcoes: [
          { value: 'PEDIDO', text: 'Data do Pedido' },
          { value: 'SAIDA', text: 'Data da Prefatura/venda' }
        ]
      },
      tipoMovimentacao: {
        valor: '',
        opcoes: [{ value: '', text: 'Todos os tipos de movimentacao' }]
      },
      parametros: {}
    }
  },
  computed: {
    isDark () {
      return this.$store.getters['tema/IS_DARK']
    },
    isVendedor () {
      return !((localStorage.getItem('vendedorId') === undefined) || (localStorage.getItem('vendedorId') === '100') || (localStorage.getItem('vendedorId') === null))
    },
    isValid () {
      return !!this.filtros.dt1 && !!this.filtros.dt2
    },
    tipoSelecionado () {
      return this.opcoesRelatorio.find(o => o.value === this.tipoRelatorio) || {}
    },
    opcoesRelatorio () {
      return [
        { value: 'ANALITICO_DATA', text: 'Analitico por Data' },
        { value: 'ANALITICO_CLIENTE', text: 'Analitico por Cliente' },
        { value: 'ANALITICO_GRUPO', text: 'Analitico por Grupo de Produto' },
        { value: 'ANALITICO_VENDEDOR', text: 'Analitico por Vendedor' },
        { value: 'ANALITICO_PRODUTO', text: 'Analitico por Produto' },
        { value: 'ANALITICO_TODOS', text: 'Analitico por Todos' },
        { value: 'SINTETICO_CLIENTE', text: 'Sintetico por Cliente' },
        { value: 'SINTETICO_GRUPO', text: 'Sintetico por Grupo de Produto' },
        { value: 'SINTETICO_VENDEDOR', text: 'Sintetico por Vendedor' },
        { value: 'SINTETICO_PRODUTO', text: 'Sintetico por Produto' },
        { value: 'ACUMULADO_CLIENTE', text: 'Acumulado por Cliente' },
        { value: 'ACUMULADO_GRUPO', text: 'Acumulado por Grupo de Produto' },
        { value: 'ACUMULADO_VENDEDOR', text: 'Acumulado por Vendedor' },
        { value: 'ACUMULADO_PRODUTO', text: 'Acumulado por Produto' },
        { value: 'ACUMULADO_CLIENTE_PRODUTO', text: 'Acumulado por Cliente e Produto' },
        { value: 'ACUMULADO_CLIENTE_GRUPO', text: 'Acumulado por Cliente e Grupo' },
        { value: 'ACUMULADO_VENDEDOR_PRODUTO', text: 'Acumulado por Vendedor e Produto' },
        { value: 'ACUMULADO_GRUPO_PRODUTO', text: 'Acumulado por Grupo e Produto' },
        { value: 'FINANCEIRO_PEDIDO', text: 'Financeiro por Pedido' },
        { value: 'FINANCEIRO_CLIENTE', text: 'Financeiro por Cliente' },
        { value: 'FINANCEIRO_VENDEDOR', text: 'Financeiro por Vendedor' },
        { value: 'FINANCEIRO_TITULOS_PEDIDO', text: 'Titulos em Aberto por Pedido' },
        { value: 'LUCRATIVIDADE_PEDIDO', text: 'Lucratividade por Pedido' },
        { value: 'LUCRATIVIDADE_ITEM', text: 'Lucratividade por Item' },
        { value: 'LUCRATIVIDADE_CLIENTE', text: 'Lucratividade por Cliente' },
        { value: 'LUCRATIVIDADE_VENDEDOR', text: 'Lucratividade por Vendedor' },
        { value: 'LUCRATIVIDADE_PRODUTO', text: 'Lucratividade por Produto' },
        { value: 'LUCRATIVIDADE_GRUPO', text: 'Lucratividade por Grupo de Produto' }
      ]
    }
  },
  methods: {
    getLabelFromDropDown (refName, value) {
      if (!value) return ''
      const component = this.$refs[refName]
      if (component && component.options) {
        const option = component.options.find(o => String(o.value) === String(value))
        return option ? option.text : ''
      }
      return ''
    },
    getLabelFromOptions (options, value) {
      const option = options.find(o => String(o.value) === String(value))
      return option ? option.text : ''
    },
    traduzirSituacao (registro) {
      const item = registro && typeof registro === 'object' ? registro : null
      const valor = item ? item.SITUACAO : registro
      if (valor === '0') return 'CANCELADO'
      else if (valor === '1') return 'FECHADO / AGUARD. CARGA'
      else if (valor === '2') return 'LANCANDO'
      else if (valor === '3') return 'AGUARD. ORDEM'
      else if (valor === '4') return 'ORDEM EXP'
      else if (valor === '5') return 'EMBARCANDO'
      else if (valor === '6') return item && String(item.OP_CONFERENCIA_VENDA || '0').trim() === '1' ? 'CONFERIDO' : 'EMBARCADO'
      else if (valor === '7') return 'AGUARD. CONF.'
      else if (valor === '8') return 'EM CONFERENCIA'
      else return ''
    },
    montarOpcoesSituacao () {
      const opExpedicaoDireta = String(this.parametros.OP_EXPEDICAO_DIRETA || '0').trim()
      const opcoes = [{ value: '', text: 'Todos' }]
      const adicionarSituacao = (value, text) => {
        if (!opcoes.some(o => String(o.value) === String(value))) {
          opcoes.push({ value, text: text || this.traduzirSituacao(value) })
        }
      }

      adicionarSituacao('0')
      adicionarSituacao('1')
      adicionarSituacao('2')

      if (opExpedicaoDireta === '2') {
        adicionarSituacao('7')
        adicionarSituacao('8')
        adicionarSituacao('6', 'CONFERIDO')
      } else {
        adicionarSituacao('3')
        adicionarSituacao('4')
        adicionarSituacao('5')
        adicionarSituacao('6')
      }

      this.situacao.opcoes = opcoes
      if (!opcoes.some(o => String(o.value) === String(this.situacao.valor))) {
        this.situacao.valor = ''
      }
    },
    async carregarParametros () {
      const response = await this.$http.get(this.$http.defaults.baseURL.concat('api/protected/parametro/getDados'))
      this.parametros = response.data?.[0] || {}
      this.montarOpcoesSituacao()
    },
    async carregarTiposMovimentacao () {
      const response = await this.$http.get('/api/protected/tipoMovimentacao/listar')
      const tipos = Array.isArray(response.data) ? response.data : []
      this.tipoMovimentacao.opcoes = [
        { value: '', text: 'Todos os tipos de movimentacao' },
        ...tipos.map(item => ({
          value: item.ID,
          text: item.TRADUCAO || `${item.ID} - ${item.DESCRICAO || ''}`.trim()
        }))
      ]
    },
    fmtDate (value) {
      return value ? moment(value).format('DD/MM/YYYY') : ''
    },
    fmtNumber (value, digits = 2) {
      return Number(value || 0).toLocaleString('pt-BR', { minimumFractionDigits: digits, maximumFractionDigits: digits })
    },
    fmtCurrency (value) {
      return this.fmtNumber(value, 2)
    },
    getParams () {
      return {
        dt1: this.filtros.dt1,
        dt2: this.filtros.dt2,
        clienteId: this.filtros.clienteId || '',
        vendedorId: this.filtros.vendedorId || '',
        produtoId: this.filtros.produtoId || '',
        grupoProdutoId: this.filtros.grupoProdutoId || '',
        situacao: this.situacao.valor || '',
        tipoData: this.tipoData.valor,
        tipoMovimentacaoId: this.tipoMovimentacao.valor || '',
        tipoRelatorio: this.tipoRelatorio,
        lbCliente: this.$refs.clientePesquisa?.$refs?.auto?.display || '',
        lbVendedor: this.getLabelFromDropDown('vendedorPesquisa', this.filtros.vendedorId),
        lbProduto: this.$refs.produtoPesquisa?.$refs?.auto?.display || '',
        lbGrupoProduto: this.getLabelFromDropDown('grupoProdutoPesquisa', this.filtros.grupoProdutoId),
        lbSituacao: this.getLabelFromOptions(this.situacao.opcoes, this.situacao.valor),
        lbTipoData: this.getLabelFromOptions(this.tipoData.opcoes, this.tipoData.valor),
        lbTipoMovimentacao: this.getLabelFromOptions(this.tipoMovimentacao.opcoes, this.tipoMovimentacao.valor),
        lbUsuario: window.localStorage.getItem('nomeusuario') || ''
      }
    },
    getObservacoes (dados) {
      const filtros = dados.filtros || {}
      const linhas = [
        `Periodo: ${this.fmtDate(filtros.dt1)} a ${this.fmtDate(filtros.dt2)}`,
        filtros.tipoData ? `Tipo de Data: ${filtros.tipoData}` : '',
        filtros.cliente ? `Cliente: ${filtros.cliente}` : '',
        filtros.vendedor ? `Vendedor: ${filtros.vendedor}` : '',
        filtros.produto ? `Produto: ${filtros.produto}` : '',
        filtros.grupoProduto ? `Grupo de Produto: ${filtros.grupoProduto}` : '',
        filtros.situacao ? `Situacao: ${filtros.situacao}` : '',
        filtros.tipoMovimentacao ? `Tipo de Movimentacao: ${filtros.tipoMovimentacao}` : ''
      ]
      return linhas.filter(Boolean).join('\n')
    },
    isRelatorioLucratividade () {
      return this.tipoRelatorio.startsWith('LUCRATIVIDADE')
    },
    getGroupBy () {
      const map = {
        ANALITICO_DATA: { key: 'DATA_REFERENCIA', formatter: this.fmtDate },
        ANALITICO_CLIENTE: { key: 'NOME_CLIENTE' },
        ANALITICO_GRUPO: { key: 'NOME_GRUPO' },
        ANALITICO_VENDEDOR: { key: 'NOME_VENDEDOR' },
        ANALITICO_PRODUTO: { key: 'NOME_PRODUTO' },
        ACUMULADO_CLIENTE_PRODUTO: { key: 'NOME_CLIENTE' },
        ACUMULADO_CLIENTE_GRUPO: { key: 'NOME_CLIENTE' },
        ACUMULADO_VENDEDOR_PRODUTO: { key: 'NOME_VENDEDOR' },
        ACUMULADO_GRUPO_PRODUTO: { key: 'NOME_GRUPO' },
        FINANCEIRO_PEDIDO: { key: 'NOME_CLIENTE' },
        FINANCEIRO_TITULOS_PEDIDO: {
          getKey: row => row.PEDIDO_ID,
          getLabel: row => `Pedido ${row.PEDIDO_ID || ''} - ${row.NOME_CLIENTE || ''}`
        },
        LUCRATIVIDADE_PEDIDO: { key: 'NOME_CLIENTE' },
        LUCRATIVIDADE_ITEM: {
          getKey: row => row.PEDIDO_ID,
          getLabel: row => `Pedido ${row.PEDIDO_ID || ''} - ${row.NOME_CLIENTE || ''}`
        }
      }
      return map[this.tipoRelatorio] || null
    },
    getColumns () {
      const number = (digits = 2) => (value) => this.fmtNumber(value, digits)
      const currency = (value) => this.fmtCurrency(value)
      const date = (value) => this.fmtDate(value)
      const lucroPercentual = (rows) => {
        const vlLiquido = rows.reduce((sum, row) => sum + (Number(row.VL_LIQUIDO) || 0), 0)
        const vlLucro = rows.reduce((sum, row) => sum + (Number(row.VL_LUCRO) || 0), 0)
        return vlLiquido !== 0 ? (vlLucro / vlLiquido) * 100 : 0
      }

      if (this.isRelatorioLucratividade()) {
        if (this.tipoRelatorio === 'LUCRATIVIDADE_ITEM') {
          return [
            { key: 'PEDIDO_ID', label: 'Pedido', type: 'number', formatter: number(0), width: '6%' },
            { key: 'DATA_REFERENCIA', label: 'Data', type: 'date', formatter: date, width: '6%' },
            { key: 'CLIENTE_ID', label: 'Cod. Cliente', type: 'number', formatter: number(0), width: '5%' },
            { key: 'NOME_CLIENTE', label: 'Cliente', width: '13%' },
            { key: 'NOME_VENDEDOR', label: 'Vendedor', width: '9%' },
            { key: 'USUARIO_CADASTRO', label: 'Usuario Cad.', width: '8%' },
            { key: 'PRODUTO_ID', label: 'Cod. Produto', type: 'number', formatter: number(0), width: '5%' },
            { key: 'NOME_PRODUTO', label: 'Produto', width: '14%' },
            { key: 'PECAS_PEDIDO', label: 'Pecas Pedido', type: 'number', formatter: number(0), width: '5%' },
            { key: 'PECAS', label: 'Volumes', type: 'number', formatter: number(0), width: '5%' },
            { key: 'QUANTIDADE', label: 'Quantidade', type: 'number', formatter: number(2), width: '6%' },
            { key: 'VL_UNITARIO', label: 'Venda Unit. (R$)', type: 'currency', formatter: currency, width: '7%' },
            { key: 'VL_CUSTO', label: 'Custo Unit. (R$)', type: 'currency', formatter: currency, width: '7%' },
            { key: 'VL_LIQUIDO', label: 'Venda (R$)', type: 'currency', formatter: currency, width: '7%' },
            { key: 'VL_CUSTO_TOTAL', label: 'Custo (R$)', type: 'currency', formatter: currency, width: '7%' },
            { key: 'VL_LUCRO', label: 'Lucro (R$)', type: 'currency', formatter: currency, width: '7%' },
            { key: 'PC_LUCRO', label: '% Lucro', type: 'number', formatter: number(2), summary: lucroPercentual, width: '6%' }
          ]
        }

        if (this.tipoRelatorio === 'LUCRATIVIDADE_PEDIDO') {
          return [
            { key: 'PEDIDO_ID', label: 'Pedido', type: 'number', formatter: number(0), width: '7%' },
            { key: 'DATA_REFERENCIA', label: 'Data', type: 'date', formatter: date, width: '7%' },
            { key: 'CLIENTE_ID', label: 'Cod. Cliente', type: 'number', formatter: number(0), width: '7%' },
            { key: 'NOME_CLIENTE', label: 'Cliente', width: '22%' },
            { key: 'NOME_VENDEDOR', label: 'Vendedor', width: '13%' },
            { key: 'USUARIO_CADASTRO', label: 'Usuario Cad.', width: '9%' },
            { key: 'QT_ITENS', label: 'Itens', type: 'number', formatter: number(0), width: '6%' },
            { key: 'PECAS_PEDIDO', label: 'Pecas Pedido', type: 'number', formatter: number(0), width: '7%' },
            { key: 'PECAS', label: 'Volumes', type: 'number', formatter: number(0), width: '6%' },
            { key: 'QUANTIDADE', label: 'Quantidade', type: 'number', formatter: number(2), width: '7%' },
            { key: 'VL_LIQUIDO', label: 'Venda (R$)', type: 'currency', formatter: currency, width: '8%' },
            { key: 'VL_CUSTO_TOTAL', label: 'Custo (R$)', type: 'currency', formatter: currency, width: '8%' },
            { key: 'VL_LUCRO', label: 'Lucro (R$)', type: 'currency', formatter: currency, width: '8%' },
            { key: 'PC_LUCRO', label: '% Lucro', type: 'number', formatter: number(2), summary: lucroPercentual, width: '7%' }
          ]
        }

        const groupColumns = []
        if (this.tipoRelatorio.includes('CLIENTE')) {
          groupColumns.push({ key: 'CLIENTE_ID', label: 'Cod. Cliente', type: 'number', formatter: number(0), width: '8%' })
          groupColumns.push({ key: 'NOME_CLIENTE', label: 'Cliente', width: '21%' })
        }
        if (this.tipoRelatorio.includes('VENDEDOR')) groupColumns.push({ key: 'NOME_VENDEDOR', label: 'Vendedor', width: '22%' })
        if (this.tipoRelatorio.includes('GRUPO')) groupColumns.push({ key: 'NOME_GRUPO', label: 'Grupo', width: '22%' })
        if (this.tipoRelatorio.includes('PRODUTO')) {
          groupColumns.push({ key: 'PRODUTO_ID', label: 'Cod. Produto', type: 'number', formatter: number(0), width: '8%' })
          groupColumns.push({ key: 'NOME_PRODUTO', label: 'Produto', width: '22%' })
        }

        return [
          ...groupColumns,
          { key: 'QT_PEDIDOS', label: 'Pedidos', type: 'number', formatter: number(0), width: '7%' },
          { key: 'QT_ITENS', label: 'Itens', type: 'number', formatter: number(0), width: '6%' },
          { key: 'PECAS_PEDIDO', label: 'Pecas Pedido', type: 'number', formatter: number(0), width: '7%' },
          { key: 'PECAS', label: 'Volumes', type: 'number', formatter: number(0), width: '6%' },
          { key: 'QUANTIDADE', label: 'Quantidade', type: 'number', formatter: number(2), width: '8%' },
          { key: 'VL_PRECO_MEDIO', label: 'Preco Medio (R$)', type: 'currency', formatter: currency, width: '8%' },
          { key: 'VL_CUSTO_MEDIO', label: 'Custo Medio (R$)', type: 'currency', formatter: currency, width: '8%' },
          { key: 'VL_LIQUIDO', label: 'Venda (R$)', type: 'currency', formatter: currency, width: '9%' },
          { key: 'VL_CUSTO_TOTAL', label: 'Custo (R$)', type: 'currency', formatter: currency, width: '9%' },
          { key: 'VL_LUCRO', label: 'Lucro (R$)', type: 'currency', formatter: currency, width: '9%' },
          { key: 'PC_LUCRO', label: '% Lucro', type: 'number', formatter: number(2), summary: lucroPercentual, width: '7%' }
        ]
      }

      if (this.tipoRelatorio === 'FINANCEIRO_PEDIDO') {
        return [
          { key: 'PEDIDO_ID', label: 'Pedido', type: 'number', formatter: number(0), width: '7%' },
          { key: 'DATA_REFERENCIA', label: 'Data', type: 'date', formatter: date, width: '7%' },
          { key: 'CLIENTE_ID', label: 'Cod. Cliente', type: 'number', formatter: number(0), width: '6%' },
          { key: 'NOME_CLIENTE', label: 'Cliente', width: '22%' },
          { key: 'NOME_VENDEDOR', label: 'Vendedor', width: '13%' },
          { key: 'USUARIO_CADASTRO', label: 'Usuario Cad.', width: '9%' },
          { key: 'QT_ITENS', label: 'Itens', type: 'number', formatter: number(0), width: '6%' },
          { key: 'PECAS_PEDIDO', label: 'Pecas Pedido', type: 'number', formatter: number(0), width: '6%' },
          { key: 'PECAS', label: 'Volumes', type: 'number', formatter: number(0), width: '6%' },
          { key: 'QUANTIDADE', label: 'Quantidade', type: 'number', formatter: number(2), width: '7%' },
          { key: 'QT_TITULOS', label: 'Titulos', type: 'number', formatter: number(0), width: '6%' },
          { key: 'PRIMEIRO_VENCIMENTO', label: '1o Venc.', type: 'date', formatter: date, width: '8%' },
          { key: 'ULTIMO_VENCIMENTO', label: 'Ult. Venc.', type: 'date', formatter: date, width: '8%' },
          { key: 'VL_LIQUIDO', label: 'Venda (R$)', type: 'currency', formatter: currency, width: '8%' },
          { key: 'VL_ARECEBER', label: 'Aberto (R$)', type: 'currency', formatter: currency, width: '9%' }
        ]
      }

      if (this.tipoRelatorio === 'FINANCEIRO_CLIENTE' || this.tipoRelatorio === 'FINANCEIRO_VENDEDOR') {
        const groupColumns = []
        if (this.tipoRelatorio === 'FINANCEIRO_CLIENTE') {
          groupColumns.push({ key: 'CLIENTE_ID', label: 'Cod. Cliente', type: 'number', formatter: number(0), width: '9%' })
          groupColumns.push({ key: 'NOME_CLIENTE', label: 'Cliente', width: '31%' })
        } else {
          groupColumns.push({ key: 'VENDEDOR_ID', label: 'Cod. Vendedor', type: 'number', formatter: number(0), width: '10%' })
          groupColumns.push({ key: 'NOME_VENDEDOR', label: 'Vendedor', width: '30%' })
        }
        return [
          ...groupColumns,
          { key: 'QT_PEDIDOS', label: 'Pedidos', type: 'number', formatter: number(0), width: '9%' },
          { key: 'QT_ITENS', label: 'Itens', type: 'number', formatter: number(0), width: '8%' },
          { key: 'PECAS_PEDIDO', label: 'Pecas Pedido', type: 'number', formatter: number(0), width: '8%' },
          { key: 'PECAS', label: 'Volumes', type: 'number', formatter: number(0), width: '8%' },
          { key: 'QUANTIDADE', label: 'Quantidade', type: 'number', formatter: number(2), width: '9%' },
          { key: 'QT_TITULOS', label: 'Titulos', type: 'number', formatter: number(0), width: '8%' },
          { key: 'VL_LIQUIDO', label: 'Venda (R$)', type: 'currency', formatter: currency, width: '12%' },
          { key: 'VL_ARECEBER', label: 'Aberto (R$)', type: 'currency', formatter: currency, width: '12%' },
          { key: 'PC_ABERTO', label: '% Aberto', type: 'number', formatter: number(2), width: '10%' }
        ]
      }

      if (this.tipoRelatorio === 'FINANCEIRO_TITULOS_PEDIDO') {
        return [
          { key: 'DOCUMENTO', label: 'Documento', width: '9%' },
          { key: 'PARCELA', label: 'Parc.', width: '5%' },
          { key: 'CLIENTE_ID', label: 'Cod. Cliente', type: 'number', formatter: number(0), width: '7%' },
          { key: 'NOME_CLIENTE', label: 'Cliente', width: '23%' },
          { key: 'NOME_VENDEDOR', label: 'Vendedor', width: '11%' },
          { key: 'USUARIO_CADASTRO', label: 'Usuario Cad.', width: '8%' },
          { key: 'PECAS_PEDIDO', label: 'Pecas Pedido', type: 'number', formatter: number(0), width: '6%' },
          { key: 'PECAS', label: 'Volumes', type: 'number', formatter: number(0), width: '6%' },
          { key: 'QUANTIDADE', label: 'Quantidade', type: 'number', formatter: number(2), width: '7%' },
          { key: 'DATA_DOCUMENTO', label: 'Emissao', type: 'date', formatter: date, width: '8%' },
          { key: 'DATA_VENCIMENTO', label: 'Vencimento', type: 'date', formatter: date, width: '8%' },
          { key: 'DIAS_VENCIDO', label: 'Dias', type: 'number', formatter: number(0), width: '5%' },
          { key: 'CONTA_BOLETO', label: 'Boleto', width: '8%' },
          { key: 'VL_TITULO', label: 'Titulo (R$)', type: 'currency', formatter: currency, width: '8%' },
          { key: 'VL_ARECEBER', label: 'Aberto (R$)', type: 'currency', formatter: currency, width: '8%' }
        ]
      }

      if (this.tipoRelatorio.startsWith('ANALITICO')) {
        return [
          { key: 'PEDIDO_ID', label: 'Pedido', type: 'number', width: '7%', formatter: number(0) },
          { key: 'DATA_REFERENCIA', label: 'Data', type: 'date', width: '7%', formatter: date },
          { key: 'CLIENTE_ID', label: 'Cod. Cliente', type: 'number', formatter: number(0), width: '5%' },
          { key: 'NOME_CLIENTE', label: 'Cliente', width: '14%' },
          { key: 'NOME_VENDEDOR', label: 'Vendedor', width: '11%' },
          { key: 'USUARIO_CADASTRO', label: 'Usuario Cad.', width: '8%' },
          { key: 'NOME_GRUPO', label: 'Grupo', width: '10%' },
          { key: 'PRODUTO_ID', label: 'Cod. Produto', type: 'number', formatter: number(0), width: '5%' },
          { key: 'NOME_PRODUTO', label: 'Produto', width: '16%' },
          { key: 'PECAS_PEDIDO', label: 'Pecas Pedido', type: 'number', formatter: number(0), width: '5%' },
          { key: 'PECAS', label: 'Volumes', type: 'number', formatter: number(0), width: '5%' },
          { key: 'QUANTIDADE', label: 'Quantidade', type: 'number', formatter: number(2), width: '6%' },
          { key: 'VL_UNITARIO', label: 'Unitario (R$)', type: 'currency', formatter: currency, width: '7%' },
          { key: 'VL_BRUTO', label: 'Bruto (R$)', type: 'currency', formatter: currency, width: '7%' },
          { key: 'VL_LIQUIDO', label: 'Liquido (R$)', type: 'currency', formatter: currency, width: '7%' }
        ]
      }

      const groupColumns = []
      if (this.tipoRelatorio.includes('CLIENTE')) {
        groupColumns.push({ key: 'CLIENTE_ID', label: 'Cod. Cliente', type: 'number', formatter: number(0), width: '8%' })
        groupColumns.push({ key: 'NOME_CLIENTE', label: 'Cliente', width: '22%' })
      }
      if (this.tipoRelatorio.includes('VENDEDOR')) groupColumns.push({ key: 'NOME_VENDEDOR', label: 'Vendedor', width: '18%' })
      if (this.tipoRelatorio.includes('GRUPO')) groupColumns.push({ key: 'NOME_GRUPO', label: 'Grupo', width: '20%' })
      if (this.tipoRelatorio.includes('PRODUTO')) {
        groupColumns.push({ key: 'PRODUTO_ID', label: 'Cod. Produto', type: 'number', formatter: number(0), width: '8%' })
        groupColumns.push({ key: 'NOME_PRODUTO', label: 'Produto', width: '24%' })
      }

      return [
        ...groupColumns,
        { key: 'QT_PEDIDOS', label: 'Pedidos', type: 'number', formatter: number(0), width: '8%' },
        { key: 'QT_ITENS', label: 'Itens', type: 'number', formatter: number(0), width: '7%' },
        { key: 'PECAS_PEDIDO', label: 'Pecas Pedido', type: 'number', formatter: number(0), width: '7%' },
        { key: 'PECAS', label: 'Volumes', type: 'number', formatter: number(0), width: '7%' },
        { key: 'QUANTIDADE', label: 'Quantidade', type: 'number', formatter: number(2), width: '8%' },
        { key: 'VL_UNITARIO_MEDIO', label: 'Unit. Medio (R$)', type: 'currency', formatter: currency, width: '10%' },
        { key: 'VL_BRUTO', label: 'Bruto (R$)', type: 'currency', formatter: currency, width: '10%' },
        { key: 'VL_LIQUIDO', label: 'Liquido (R$)', type: 'currency', formatter: currency, width: '10%' }
      ]
    },
    getSumKeys () {
      if (this.tipoRelatorio === 'FINANCEIRO_TITULOS_PEDIDO') {
        return ['VL_TITULO', 'VL_ARECEBER']
      }
      if (this.isRelatorioLucratividade()) {
        return ['QT_PEDIDOS', 'QT_ITENS', 'PECAS_PEDIDO', 'PECAS', 'QUANTIDADE', 'VL_LIQUIDO', 'VL_CUSTO_TOTAL', 'VL_LUCRO', 'PC_LUCRO']
      }
      return ['QT_PEDIDOS', 'QT_ITENS', 'QT_TITULOS', 'PECAS_PEDIDO', 'PECAS', 'QUANTIDADE', 'VL_BRUTO', 'VL_LIQUIDO', 'VL_TITULO', 'VL_ARECEBER']
    },
    deveUsarPaisagem () {
      return this.tipoRelatorio.startsWith('ANALITICO') ||
        this.isRelatorioLucratividade() ||
        this.tipoRelatorio.startsWith('FINANCEIRO') ||
        this.tipoRelatorio === 'FINANCEIRO_PEDIDO' ||
        this.tipoRelatorio === 'FINANCEIRO_TITULOS_PEDIDO' ||
        this.tipoRelatorio.includes('_PRODUTO') ||
        this.tipoRelatorio.includes('_GRUPO')
    },
    gerarHtml (dados) {
      const rows = dados.linhas || []
      printGroupedHtmlReport({
        rows,
        columns: this.getColumns(),
        groupBy: this.getGroupBy(),
        sumKeys: this.getSumKeys(),
        systemName: dados.empresa?.FANTASIA || window.localStorage.getItem('nomeempresa') || '',
        reportTitle: `Relatorio de Pedidos - ${this.tipoSelecionado.text}`,
        printedBy: window.localStorage.getItem('nomeusuario') || '',
        observations: this.getObservacoes(dados),
        landscape: this.deveUsarPaisagem(),
        autoPrint: true
      })
    },
    gerarRelatorio () {
      if (!this.isValid) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o periodo do relatorio')
        return
      }

      this.$store.commit('controle/setAguardando', true)
      const uri = '/api/protected/relatorios/pedido-venda?' + new URLSearchParams(this.getParams()).toString()
      this.$http.get(uri)
        .then(response => {
          const dados = response.data || {}
          if (!dados.linhas || dados.linhas.length === 0) {
            Tools.exibirMensagem(this.$store, 'Aviso', 'info', 'Nenhuma informacao para o filtro selecionado')
            return
          }
          this.gerarHtml(dados)
        })
        .catch((err) => {
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', err || 'Ocorreram erros ao gerar o relatorio')
        })
        .finally(() => {
          this.$store.commit('controle/setAguardando', false)
        })
    }
  },
  async created () {
    if (this.isVendedor) {
      this.filtros.vendedorId = localStorage.getItem('vendedorId')
    }
    try {
      await this.carregarParametros()
    } catch (err) {
      this.montarOpcoesSituacao()
      Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err || 'Nao foi possivel carregar os parametros do sistema')
    }
    try {
      await this.carregarTiposMovimentacao()
    } catch (err) {
      Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err || 'Nao foi possivel carregar os tipos de movimentacao')
    }
  }
}
</script>

<style scoped>
.bg-primary-soft { background-color: rgba(32, 168, 216, 0.1); }
.bg-secondary-soft { background-color: rgba(108, 117, 125, 0.1); }
.bg-dark-darker { background-color: #1e2225; }

.section-container {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e4e7ea;
  transition: all 0.3s ease;
}

.section-container:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.section-container.dark-mode {
  background: #2f353a;
  border-color: #434a50;
}

.section-title {
  color: #20a8d8;
  border-bottom: 1px solid #c2cfd6;
  padding-bottom: 8px;
  margin-bottom: 20px;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 1px;
}

.section-title.dark-mode {
  color: #63c2de;
  border-color: #434a50;
}

.btn-generate {
  font-weight: 700;
  letter-spacing: 1px;
  padding: 12px;
  transition: all 0.3s;
}

.btn-generate:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(32, 168, 216, 0.4);
}
</style>



// WEBPACK FOOTER //
// src/views/relatorios/RelPedidoVenda.vue